import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/payment-bank-transfer/constants'


const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const PaymentBankTransferStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.PROCESSING] : 'info',
    [STATUS.COMPLETED]  : 'success',
    [STATUS.REJECTED]   : 'danger'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

PaymentBankTransferStatusBadge.propTypes = propTypes

export default PaymentBankTransferStatusBadge